import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPen,
    faUserGroup,
    faUser,
    faPlus,
    faTimes,
    faCheck,
    faArrowRightFromBracket
} from "@fortawesome/free-solid-svg-icons";
import "./FloatingButton.scss";

function FloatingButton({ typeOfButton, onClickFcn, align="right", alignVertical="bottom", text }) {
    //const { typeOfButton, onClickFcn, align="right", alignVertical="bottom", text } = props;

    // this button handles both the buttons on the bottom corners of the screen and the top sign out button.
    // the top sign out button changes significantly on mobile and desktop so we had to do weird things

    const iconMap = {
        pen: faPen,
        userGroup: faUserGroup,
        user: faUser,
        plus: faPlus,
        xMark: faTimes,
        check: faCheck,
        logOut: faArrowRightFromBracket
    };

    // if no type of button is provided, it defaults to the pen
    

    const selectedIcon = iconMap[typeOfButton] || faPen;
    
    // init custom styling object where we will put custom inline styling
    const customStyling = {}

    // we use the custom styling object here to align the button to the left or right, or top/bottom depending on props given
    if(align == "right") {
        customStyling.right = "28px";
    } else if (align =="left") {
        customStyling.left = "28px";
    }
    if(alignVertical == "bottom") {
        customStyling.bottom = "28px";
    } else if (alignVertical =="top") {
        customStyling.top = "28px";
    }


    // we check for mobile because styling is different for the log out button
    // we also check for the text prop, so we do some different styling for the log out button
    if (window.innerWidth > 768) {
        return (
            <button style={customStyling} className={text?'floatingButton':'floatingButton floatingButtonNoText'} onClick={onClickFcn}>
                
                <div className="floatingButtonIconPlaceHolder">
                <FontAwesomeIcon
                    className="floatingButtonIcon"
                    icon={selectedIcon}
                />
                </div>
                {text && <div className="floatingButtonSignOutTextPlaceHolder">
                    <div className="floatingButtonSignOutText">{text}</div>
                </div>} 
            </button>
        );
    } else {
        return (
            <button style={customStyling} className={text?'floatingButton':'floatingButton floatingButtonNoText'} onClick={onClickFcn}>
                {text && <div className="floatingButtonSignOutTextPlaceHolder">
                    <div className="floatingButtonSignOutText">{text}</div>
                </div>} 
                {!text && <div className="floatingButtonIconPlaceHolder">
                <FontAwesomeIcon
                    className="floatingButtonIcon"
                    icon={selectedIcon}
                />
                </div>
                }
            </button>
        );
    }
}

export default FloatingButton;
